'use client';

import { type ComponentProps } from 'react';
import { AppBar } from './AppBar';
import { utilStyles } from '~/styles';
import { IcChevronLeft } from '@bgzt/ui';
import { useGoBack } from '~/hooks';

const DISPLAY_NAME = 'BackButton';

type Props = {
  config: ComponentProps<typeof AppBar>['back'];
};

export const BackButton = ({ config = true }: Props) => {
  const { goBack } = useGoBack();

  return (
    <button
      onClick={(event) => {
        goBack();

        if (event.defaultPrevented) return;
        if (typeof config === 'boolean') return;
        config?.onClick?.(event);
      }}
      {...(config === true ? {} : config)}
    >
      <span className={utilStyles.visuallyHidden}>뒤로가기</span>
      <IcChevronLeft size={20} />
    </button>
  );
};

BackButton.displayName = DISPLAY_NAME;
